/**
 * Calculates the initial number of items to show based on dimension limits and available refinements
 */
export function getInitialItemsToShowCount(dimension, refinements = []) {
  const { nestedRefinementsLimit } = dimension || {};

  if (nestedRefinementsLimit == null) {
    return nestedRefinementsLimit;
  }

  const refinementCount = refinements.length;
  const MAX_SHOW_ALL_THRESHOLD = 6;
  const TRUNCATED_SHOW_COUNT = 5;

  return refinementCount <= MAX_SHOW_ALL_THRESHOLD
    ? refinementCount
    : TRUNCATED_SHOW_COUNT;
}
